import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "like_active",
  "use": "like_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"like_active\"><path fill-rule=\"evenodd\" d=\"M9.583 5.718s.584-.686.665-.798C10.975 4.118 12.178 3 13.23 3a4.93 4.93 0 0 1 4.935 4.935c0 2.392-1.47 4.828-4.205 7.049-1.502 1.255-3.144 2.231-4.077 2.682-.086.043-.3.064-.3.064s-.193-.021-.3-.054c-.934-.461-2.576-1.437-4.077-2.682C2.47 12.763 1 10.317 1 7.935A4.93 4.93 0 0 1 5.935 3c1.309 0 2.24.83 3.041 1.87.07.126.607.848.607.848Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol